import { Modal } from '@calendly/ui/components/modal';
import { UiConfig } from '@calendly/ui/config';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SchedulesTab } from 'features/availability';
import { setIsETEditorSidePanelOpen } from 'features/event_type_editor/slice';
import { etEditorOverlayZIndex } from 'shared/modal_stacking';
import { eventTypePreviewDataSelector } from '../../../../../../selectors';
const containerIsTabletDownCss = "c1mlcubu";
const containerCss = "c15nfyfj";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletDown = useDeviceType('isTabletDown');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletDownCss]: isTabletDown
  }, props.className)} />;
});

// Size-based breakpoints for UiConfig - automatically generates named queries
// like isPhone, isTabletDown, isDesktopUp for use with useDeviceType()
// Note: large is 1200 instead of the default 1100 to accommodate the modal layout
const customBreakpoints = {
  small: 500,
  medium: 800,
  large: 1200,
  xLarge: 1500
};
export const DefaultAvailabilityModal = ({
  activeAvailabilityRuleId,
  onClose
}) => {
  const dispatch = useDispatch();
  const eventTypePreviewData = useSelector(eventTypePreviewDataSelector);
  useEffect(() => {
    dispatch(setIsETEditorSidePanelOpen(true));
    return () => dispatch(setIsETEditorSidePanelOpen(false));
  }, [dispatch]);
  return <UiConfig breakpoints={customBreakpoints}>
      <Modal isOpen zIndex={etEditorOverlayZIndex}>
        <Container>
          <SchedulesTab currentScheduleId={activeAvailabilityRuleId} currentEventType={eventTypePreviewData} trackLocation="default_schedule_modal" onClose={onClose} />
        </Container>
      </Modal>
    </UiConfig>;
};

require("./default_availability_modal.wyw-in-js.css!=!../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./default_availability_modal.js");